import { render, staticRenderFns } from "./tablo.vue?vue&type=template&id=2cb59ec5&scoped=true"
import script from "./tablo.vue?vue&type=script&lang=js"
export * from "./tablo.vue?vue&type=script&lang=js"
import style0 from "./tablo.vue?vue&type=style&index=0&id=2cb59ec5&prod&lang=scss&scoped=true"
import style1 from "./tablo.vue?vue&type=style&index=1&id=2cb59ec5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb59ec5",
  null
  
)

export default component.exports